import React, { useEffect, useState } from "react";
import "./App.css";
import "./assets/css/material-dashboard-react.css";
import { BrowserRouter } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import "./assets/css/quill.snow.css";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useAuth } from "react-oidc-context";
// import { fetchUserAttributes } from 'aws-amplify/auth';

import { DandDPaletteOptions } from "./DandDPalette";
import { PALETTE } from "@dndModels/Constants";

import NavBar from "@components/Navigation/NavBar";
import MainPage from "@views/MainPage";

import LoadingBox from "@components/input/LoadingBox";
import DandDAPI from "@dndUtilities/system_api";
import LinkModal from "@dndComponents/other/LinkModal";

const api = DandDAPI.getInstance();

export default function AppLayout() {
  const auth = useAuth();

  const [loading, setLoading] = useState(false);
  const [login_open, setLoginOpen] = useState(false);
  const [theme, setTheme] = useState(createTheme({ palette: PALETTE as DandDPaletteOptions }));
  const [user_status, setUserStatus] = useState<"" | "New User" | "Updating User" | "Error">("");

  // Handle Cognito redirect-back: close login panel and run post-auth logic
  // useEffect(() => {
  //   if (!api.user) {
  //     const userObjStr = localStorage.getItem("loginUser");
  //     if (userObjStr) {
  //       const userObj = JSON.parse(userObjStr);
  //       const user = userObj.body;
  //       setLoading(true);
  //       api.loginOld(user).then(() => {
  //         setLoading(false);
  //         api.subscription_holder.reload();
  //       });
  //     } else {
  //       if (!auth.isLoading) {
  //         if (auth.isAuthenticated) {
  //           // Clear the ?code=...&state=... from the URL
            
  //           window.history.replaceState({}, document.title, window.location.pathname);
  //           const rememberURL = localStorage.getItem("redirectRememberURL");
  //           if (rememberURL) {
  //             localStorage.removeItem("redirectRememberURL");
  //             window.location.href = rememberURL;
  //           } 
            
  //           const load = async () => {
  //             setLoginOpen(false);

  //             // const attrs = await fetchUserAttributes();
  //             // console.log(attrs.name); // Should be the Facebook display name
  //             const response = await api.login(auth);
  //             if (response === "All Good") {
  //               api.subscription_holder.reload();
  //             } else {
  //               setUserStatus(response);
  //             }
  //           }
  //           load();
  //         } else {
  //           const rememberURL = localStorage.getItem("redirectRememberURL");
  //           if (rememberURL) {
  //             localStorage.removeItem("redirectRememberURL");
  //             window.location.href = rememberURL;
  //           } 
  //           // debugger;
  //           api.subscription_holder.reload();
  //         }
  //       }
  //     }
  //   }
  // }, [auth.isAuthenticated, auth.isLoading, api.user]);
  useEffect(() => {
    if (api.user) {
      // Already logged in from a previous run — nothing to do
      return;
    }
    if (!api.online) {
      debugger;
      // Already logged in from a previous run — nothing to do
      return;
    }
  
    console.log("Checking Login");
    const userObjStr = localStorage.getItem("loginUser");
    if (userObjStr) {
      console.log(userObjStr);
      const userObj = JSON.parse(userObjStr);
      const user = userObj.body;
      setLoading(true);
      api.loginOld(user).then(() => {
        setLoading(false);
        api.subscription_holder.reload();
      });
    } else {
      console.log(auth.isAuthenticated);
      console.log(auth.isLoading);
      if (!auth.isLoading) {
        if (auth.isAuthenticated) {
          window.history.replaceState({}, document.title, window.location.pathname);
          const rememberURL = localStorage.getItem("redirectRememberURL");
          if (rememberURL) {
            localStorage.removeItem("redirectRememberURL");
            window.location.href = rememberURL;
          }
  
          const load = async () => {
            setLoginOpen(false);
            const response = await api.login(auth);
            if (response === "All Good") {
              api.subscription_holder.reload();
            } else {
              setUserStatus(response);
            }
          };
          load();
        } else {
          const rememberURL = localStorage.getItem("redirectRememberURL");
          if (rememberURL) {
            localStorage.removeItem("redirectRememberURL");
            window.location.href = rememberURL;
          } else if (window.location.href.includes("/?code")) {
            // This fixes a bug where if a user manually goes to an invalid code 
            // (usually by entering it in the browser, which sometimes it will have it as an autocomplete)
            // It will cause an issue that prevents them from being able to login at all.
            // This makes it so it will detect that situation, clear the unnecessary code from the url and send them to the root,
            // thereby fixing the problem.
            window.location.href = window.location.href.substring(0, window.location.href.indexOf("/?code="));
          }
          api.subscription_holder.reload();
        }
      }
    }
  }, [auth.isAuthenticated, auth.isLoading]); // removed api.user

  useEffect(() => {
    if (window.location.pathname.includes("printable")) {
      setTheme(createTheme({
        palette: {
          primary: {
            light: "#5F9EA0",
            main: "#5F9EA0",
            dark: "#2F4F4F"
          },
          secondary: {
            light: "#5F9EA0",
            main: "#1c3623",
            dark: "#105422"
          }
        }
      }));
      document.body.style.backgroundColor = "white";
      document.body.style.color = "black";
    }
  }, []);

  const realRender = () => {
    if (auth.isLoading || loading) {
      return (<div className="centered"><LoadingBox size={window.innerHeight * 0.5} height={window.innerHeight - 81} /></div>);
    } else {
      console.log("Rendering App");
      return (
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}>
          <Helmet>
            <title>Homebrew Labs</title>
          </Helmet>
          <div>
            {!window.location.pathname.includes("printable") &&
              <NavBar />
            }
            <div>
              <MainPage 
                userStatus={user_status} 
                loginOpen={login_open} 
                onNewUserComplete={() => {
                  setUserStatus("");
                  api.subscription_holder.reload();
                }} 
              />
              <LinkModal />
            </div>
          </div>
        </BrowserRouter>
      );
    }
  }

  return (
    <ThemeProvider theme={theme}>
      {realRender()}
    </ThemeProvider>
  );
}